import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { doSupabaseCall } from '../../shared/helpers/supabase.helper';
import type { IPonderazione } from '../../shared/models';
import { AuthService } from '../auth/auth.service';
import { SupabaseService } from '../supabase/supabase';

// Ponderazione a 100 punti + scelta di profondità (Nota_Sviluppo_v3 §2-§4), upsert su
// (fk_interview_app_id): ricompilare aggiorna la riga esistente, mai uno storico.
@Injectable({ providedIn: 'root' })
export class PonderazioneService {
  private readonly _supabase: SupabaseService = inject(SupabaseService);
  private readonly _auth: AuthService = inject(AuthService);

  // depth_* (profondità leggera/media/pesante) non si scrivono più: la schermata è stata
  // sostituita dalla scelta del percorso PRIMA dell'intervista (Tre Profondità, migrazione 0032
  // rende le colonne nullable). Le righe vecchie conservano il valore.
  public save(interviewId: string, ponderazione: IPonderazione): Observable<void> {
    const client = this._supabase.client;
    const session = this._auth.sessionSignal();
    if (null === client || null === session) {
      return of(undefined);
    }
    return doSupabaseCall(
      client.from('interview_ponderazione_app').upsert(
        {
          fk_interview_app_id: interviewId,
          weights: ponderazione.items,
          weights_total: ponderazione.total,
          confirmed_as_proposed: ponderazione.confirmedAsProposed,
          skipped: ponderazione.skipped,
          deviation_flags: ponderazione.deviationFlags,
          filled_by: ponderazione.filledBy,
          device: ponderazione.device ?? null,
          fk_auth_users_id: session.user.id,
          opened_at: ponderazione.openedAt,
          confirmed_at: ponderazione.confirmedAt ?? null,
        },
        { onConflict: 'fk_interview_app_id' },
      ),
    ).pipe(map(() => undefined));
  }
}
